// extracted by mini-css-extract-plugin
export default {"chip":"CommonChip_chip__QqNG6","icon":"CommonChip_icon__juX+f"};